import { SubmissionErrorBoundary } from '@/components/errors/SubmissionErrorBoundary';
import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { TSCard } from '@/components/shared/card/Card';
import { merge } from '@/helpers/Utility';
import { FunctionComponent } from 'react';
import { MyLeaveForm } from './MyLeaveForm';
import { MyLeaveHeader } from './MyLeaveHeader';

const MyLeave: FunctionComponent = () => {
  return (
    <PageContainer customHeader={<MyLeaveHeader />}>
      <div className="overflow-y-hidden flex flex-col bg-white">
        <PageSizer mode={SizerMode.PAGE} className="flex-1 overflow-auto">
          <SubmissionErrorBoundary>
            <TSCard className={merge('p-4 border-0 lg:border')}>
              <MyLeaveForm />
            </TSCard>
          </SubmissionErrorBoundary>
        </PageSizer>
      </div>
    </PageContainer>
  );
};

export default MyLeave;
